export default "__VITE_ASSET__CwCnT1z___"